<template>
    <v-card 
        :loading="loading"
        elevation="2"
        tile
        outlined
        >
        <v-card-title class="pa-2 px-5 primary white--text align-center">
            {{ system.name }}
            <v-spacer/>
            <span class="text-overline mr-2">{{ system.sistema_type.name }}</span>
            <v-switch v-model="is_active" :loading="loading" :disabled="loading" hide-details="" class="ma-0" color="accent"/>
            <Modal :sistema="system" @saved="system = $event" dark/>
        </v-card-title>
        <v-divider/>
        <v-card-subtitle v-if="system.description">{{ system.description }}</v-card-subtitle>
        <v-card-text>
            <v-card class="mb-2" outlined tile>
                <v-card-text class="pa-2">
                    <div class="d-flex align-center flex-wrap">
                        <small class="caption mr-2">TOKEN</small>
                        <code style="overflow-wrap: anywhere;">
                            <template v-if="system.token">{{ system.token }} <v-btn x-small icon @click="copy(system.token)"><v-icon x-small>mdi-content-copy</v-icon></v-btn></template>
                            <template v-else>SIN TOKEN</template>
                        </code>
                        <v-spacer/>
                        <v-btn @click="renewToken()" :loading="loading" :disabled="loading" small tile>RENOVAR TOKEN</v-btn>
                    </div>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <div class="d-flex align-center flex-wrap">
                        <v-checkbox
                            v-for="(ability, index) of abilityList"
                            :key="`ability-${index}-${ability}`"
                            class="mr-2"
                            v-model="selectedAbilities"
                            :label="ability"
                            :value="ability"
                            dense
                            hide-details=""
                            :disabled="loading || settingAbilities"
                            />
                            <v-progress-circular v-if="settingAbilities" indeterminate size="20" class="mt-2"/>
                    </div>
                </v-card-actions>
            </v-card>
            <v-card outlined tile>
                <v-card-text class="pa-0">
                    <v-expansion-panels tile>
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                <template v-slot:default>
                                    <div class="d-flex align-center" style="width: 100%;">
                                        <div class="caption">COMERCIO REPORTADO</div>
                                        <v-spacer/>
                                        <div>
                                            <v-chip
                                                v-for="(selection, i) in comercioList"
                                                :key="`comercio-selected-${i}-level-${selection.level}-foreign-${selection.foreign}`"
                                                label outlined :dark="isDark"
                                                class="mr-1 mb-1 px-4 py-5"
                                                >
                                                <div style="line-height: 1;">
                                                    <div class="gray"><small>{{ selection.level }}</small></div>
                                                    <div>{{ selection.name }}</div>
                                                </div>
                                            </v-chip>
                                        </div>
                                    </div>
                                </template>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <ComercioSelector outlined flat tile v-model="comercioList"/>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-card-text>
            </v-card>
        </v-card-text>
    </v-card>
</template>
<script>
import SistemaService from '@/services/operadora/comercio/sistema/SistemaService';

import Modal from './modal';
import ComercioSelector from '@components/entities/comercio/selector';

export default {
    components: {
        Modal,
        ComercioSelector
    },
    props: {
        sistema: {
            required: true
        },
        abilities: {
            required: true
        }
    },
    data: function () {
        return {
            system: this.sistema,
            selectedAbilities: this.sistema.abilities,
            is_active: this.sistema.is_active,
            loading: false,
            settingAbilities: false,
            comercioList: [],
        }
    },
    computed: {
        abilityList: function () {
            return this.abilities.filter(ability => ability.startsWith("api:monitor"));
        }
    },
    methods: {
        setIsActive(is_active) {
            this.loading = true;
            SistemaService
                .update(this.system.id, { sistema: { is_active } })
                .then(({ sistema }) => {
                    this.system = sistema;
                }).finally(() => {
                    this.loading = false;
                });
        },
        renewToken() {
            this.$ui.confirm({
                message: `Confirmar renofación de token: ${this.sistema.name}`,
                textConfirm: 'RENOVAR',
                textCancel: 'CANCELAR',
                confirm: () => {
                    this.loading = true;
                    SistemaService
                        .renewToken(this.system.id)
                        .then(({ sistema }) => {
                            this.system = sistema;
                        }).finally(() => {
                            this.loading = false;
                        });
                },
            });
        },
        async copy(text) {
            try {
                await navigator.clipboard.writeText(text);
            } catch (e) {
                console.error(e);
            }
        }
    },
    watch: {
        is_active: function (value) {
            this.setIsActive(value);
        },
        selectedAbilities: {
            deep: true,
            handler: function (value) {
                this.settingAbilities = true;
                SistemaService
                   .setAbilities(this.system.id, value)
                   .then(({ sistema }) => {
                        this.system = sistema;
                    }).finally(() => {
                        this.settingAbilities = false;
                    });
            }
        }
    }
}
</script>